/**
 * 30-day colored dot grid showing daily status.
 */

import { cn } from "@/lib/utils";

type DayStatus = "ok" | "degraded" | "down" | "unknown";

type StatusTrackerProps = {
  days: { date: string; status: DayStatus }[];
  className?: string;
};

const statusColors: Record<DayStatus, string> = {
  ok: "bg-green-500",
  degraded: "bg-yellow-500",
  down: "bg-red-500",
  unknown: "bg-muted",
};

export function StatusTracker({ days, className }: StatusTrackerProps) {
  return (
    <div className={cn("flex items-center gap-[3px]", className)}>
      {days.map((day) => (
        <div
          key={day.date}
          className={cn("h-6 w-1.5 rounded-sm", statusColors[day.status])}
          title={`${day.date}: ${day.status}`}
        />
      ))}
    </div>
  );
}
